import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

export const useUpdateDataRetentionDetails = () => {
  const { authHeader } = useAuth();

  return useMutation((params: any) => {
    return axios.patch(
      `${env.verifyServiceUrl}individual/data_retention_setting/${params.id}/`,
      params,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
